import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.user.signature');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-user-signature',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.user.signature/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PortalLpsysadminUserSignatureComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public hasSignature: boolean = false;
    public savedSignature: string = '';
    public isDrawing: boolean = false;

    private canvas: HTMLCanvasElement | null = null;
    private ctx: CanvasRenderingContext2D | null = null;
    private lastX: number = 0;
    private lastY: number = 0;
    private boundMouseDown: any;
    private boundMouseMove: any;
    private boundMouseUp: any;
    private boundTouchStart: any;
    private boundTouchMove: any;
    private boundTouchEnd: any;

    @ViewChild('signatureCanvas') set canvasRef(ref: ElementRef<HTMLCanvasElement>) {
        if (ref && !this.canvas) {
            this.canvas = ref.nativeElement;
            this.setupCanvas();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngOnDestroy() {
        this.removeListeners();
    }

    private setupCanvas() {
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext('2d')!;
        this.ctx.strokeStyle = '#000';
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';

        this.boundMouseDown = this.onMouseDown.bind(this);
        this.boundMouseMove = this.onMouseMove.bind(this);
        this.boundMouseUp = this.onMouseUp.bind(this);
        this.boundTouchStart = this.onTouchStart.bind(this);
        this.boundTouchMove = this.onTouchMove.bind(this);
        this.boundTouchEnd = this.onTouchEnd.bind(this);

        this.canvas.addEventListener('mousedown', this.boundMouseDown);
        this.canvas.addEventListener('mousemove', this.boundMouseMove);
        this.canvas.addEventListener('mouseup', this.boundMouseUp);
        this.canvas.addEventListener('mouseleave', this.boundMouseUp);
        this.canvas.addEventListener('touchstart', this.boundTouchStart, { passive: false });
        this.canvas.addEventListener('touchmove', this.boundTouchMove, { passive: false });
        this.canvas.addEventListener('touchend', this.boundTouchEnd);
    }

    private removeListeners() {
        if (!this.canvas) return;
        this.canvas.removeEventListener('mousedown', this.boundMouseDown);
        this.canvas.removeEventListener('mousemove', this.boundMouseMove);
        this.canvas.removeEventListener('mouseup', this.boundMouseUp);
        this.canvas.removeEventListener('mouseleave', this.boundMouseUp);
        this.canvas.removeEventListener('touchstart', this.boundTouchStart);
        this.canvas.removeEventListener('touchmove', this.boundTouchMove);
        this.canvas.removeEventListener('touchend', this.boundTouchEnd);
    }

    private getCanvasPos(e: MouseEvent | Touch) {
        const rect = this.canvas!.getBoundingClientRect();
        return { x: e.clientX - rect.left, y: e.clientY - rect.top };
    }

    private onMouseDown(e: MouseEvent) {
        this.isDrawing = true;
        const pos = this.getCanvasPos(e);
        this.lastX = pos.x;
        this.lastY = pos.y;
    }

    private onMouseMove(e: MouseEvent) {
        if (!this.isDrawing) return;
        const pos = this.getCanvasPos(e);
        this.ctx!.beginPath();
        this.ctx!.moveTo(this.lastX, this.lastY);
        this.ctx!.lineTo(pos.x, pos.y);
        this.ctx!.stroke();
        this.lastX = pos.x;
        this.lastY = pos.y;
    }

    private onMouseUp() {
        this.isDrawing = false;
    }

    private onTouchStart(e: TouchEvent) {
        e.preventDefault();
        const touch = e.touches[0];
        const pos = this.getCanvasPos(touch);
        this.isDrawing = true;
        this.lastX = pos.x;
        this.lastY = pos.y;
    }

    private onTouchMove(e: TouchEvent) {
        e.preventDefault();
        if (!this.isDrawing) return;
        const touch = e.touches[0];
        const pos = this.getCanvasPos(touch);
        this.ctx!.beginPath();
        this.ctx!.moveTo(this.lastX, this.lastY);
        this.ctx!.lineTo(pos.x, pos.y);
        this.ctx!.stroke();
        this.lastX = pos.x;
        this.lastY = pos.y;
    }

    private onTouchEnd() {
        this.isDrawing = false;
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code == 200) {
            this.savedSignature = data.signature_data || '';
            this.hasSignature = !!this.savedSignature;
        }
        this.loaded = true;
        await this.service.render();
    }

    public clearCanvas() {
        if (!this.canvas || !this.ctx) return;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    public async saveSignature() {
        if (!this.canvas) return;
        const signatureData = this.canvas.toDataURL('image/png');

        const blankCanvas = document.createElement('canvas');
        blankCanvas.width = this.canvas.width;
        blankCanvas.height = this.canvas.height;
        if (this.canvas.toDataURL() === blankCanvas.toDataURL()) {
            this.service.alert.error("서명을 먼저 그려주세요.");
            return;
        }

        await this.saveSignatureData(signatureData);
    }

    public async onFileSelect(event: any) {
        const file = event.target.files?.[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            this.service.alert.error("이미지 파일만 업로드할 수 있습니다.");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            this.service.alert.error("파일 크기는 2MB 이하만 가능합니다.");
            return;
        }

        const reader = new FileReader();
        reader.onload = async () => {
            const img = new Image();
            img.onload = async () => {
                const canvas = document.createElement('canvas');
                const maxW = 400, maxH = 200;
                let w = img.width, h = img.height;
                if (w > maxW || h > maxH) {
                    const ratio = Math.min(maxW / w, maxH / h);
                    w = Math.round(w * ratio);
                    h = Math.round(h * ratio);
                }
                canvas.width = w;
                canvas.height = h;
                const ctx = canvas.getContext('2d')!;
                ctx.drawImage(img, 0, 0, w, h);
                const signatureData = canvas.toDataURL('image/png');
                await this.saveSignatureData(signatureData);
            };
            img.src = reader.result as string;
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    }

    private async saveSignatureData(signatureData: string) {
        const { code } = await wiz.call("save", { signature_data: signatureData });
        if (code == 200) {
            this.service.alert.success("서명이 저장되었습니다.");
            await this.load();
            this.clearCanvas();
        } else {
            this.service.alert.error("서명 저장에 실패했습니다.");
        }
    }

    public async deleteSignature() {
        const res = await this.service.alert.show({
            title: '서명 삭제',
            message: '등록된 서명을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("delete");
        if (code == 200) {
            this.service.alert.success("서명이 삭제되었습니다.");
            this.savedSignature = '';
            this.hasSignature = false;
            await this.service.render();
        }
    }
}

export default PortalLpsysadminUserSignatureComponent;